import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, change } from 'redux-form'
import PropTypes from 'prop-types'
import TextField from 'material-ui/TextField'

import { jsonApiHttpClient } from '../services/fetch'

const searchVehicleUrl = 'https://us-central1-litroz.cloudfunctions.net/searchLicensePlate'

const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => (
  <TextField hintText={label}
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    {...custom}
  />
)

class LicensePlateField extends Component {
  constructor (props) {
    super()

    this.state = {
      licensePlate: ''
    }

    this.handleBlur = this.handleBlur.bind(this);
  }

  handleBlur () {
    const { licensePlate } = this.state

    if (licensePlate) {
      const self = this
      const url = `${searchVehicleUrl}?licensePlate=${licensePlate}`
      const options = {
        method: 'GET'
      }

      // eslint-disable-next-line
      jsonApiHttpClient(url, options)
        .then((response) => {
          const { json } = response
          self.props.changeMake(json.marca)
          self.props.changeModel(json.modelo)
          self.props.changeColor(json.cor)
          self.props.changeYear(`${json.ano}/${json.anoModelo}`)
        })
        .catch((error) => {
          console.log('Error: ', error)
        })
    }
  }

  render () {
    const { label } = this.props

    return (
      <div>
        <div>
          <Field
            name="licensePlate"
            component={renderTextField}
            label={label}
            onChange={(e, licensePlate) => this.setState({licensePlate})}
            onBlur={this.handleBlur}
          />
        </div>
        <div>
          <Field
            name="make"
            component={renderTextField}
            label="Marca"
            disabled
          />
        </div>
        <div>
          <Field
            name="model"
            component={renderTextField}
            label="Modelo"
            disabled
          />
        </div>
        <div>
          <Field
            name="color"
            component={renderTextField}
            label="Cor"
            disabled
          />
        </div>
        <div>
          <Field
            name="year"
            component={renderTextField}
            label="Ano"
            disabled
          />
        </div>
      </div>
    )
  }
}

LicensePlateField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string
}

export default connect(null, {
  changeMake: value => change('record-form', 'make', value),
  changeModel: value => change('record-form', 'model', value),
  changeColor: value => change('record-form', 'color', value),
  changeYear: value => change('record-form', 'year', value)
})(LicensePlateField)



// WEBPACK FOOTER //
// ./src/components/licensePlateField.js